var POST_SETTINGS_FIELDS = ['categoryIds', 'coverImage', 'firstPublishedDate', 'seoSlug', 'seoTitle', 'seoDescription', 'isFeatured', 'ownerId', 'ownerSiteMemberId', 'excerpt', 'canonicalUrl', 'skipPostPage', 'isCommentsDisabled'];
var POST_RCE_FIELDS = ['title', 'content'];
module.exports = {
  POST_TITLE_MAXLENGTH: 200,
  POST_CUSTOM_EXCERPT_MAX_LENGTH: 140,
  POST_EXCERPT_TRUNCATED_WORD_MAX_LENGTH: 30,
  POST_EXCERPT_MAX_LENGTH: 480,
  POST_CANONICAL_URL_MAXLENGTH: 320,
  POST_SEO_TITLE_MAXLENGTH: 200,
  POST_SEO_DESCRIPTION_MAXLENGTH: 500,
  POST_SEO_SLUG_MAXLENGTH: 100,
  POST_SEO_OLD_BLOG_SLUG_MAX_LENGTH: 2000,
  POST_CATEGORY_MAX_COUNT: 10,
  POST_TAG_MAX_COUNT: 30,
  POST_SETTINGS_FIELDS: POST_SETTINGS_FIELDS,
  POST_RCE_FIELDS: POST_RCE_FIELDS,
  POST_DRAFT_FIELDS: [].concat(POST_RCE_FIELDS, POST_SETTINGS_FIELDS),
  POST_STATUS: {
    published: 'published',
    unpublished: 'unpublished',
    scheduled: 'scheduled',
    deleted: 'deleted',
    in_moderation: 'in_moderation',
    in_review: 'in_review'
  }
};